import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Grid } from 'react-md';
import { withRouter, Redirect } from 'react-router-dom';

import { find, get } from 'lodash-es';

import { ProjectPicker } from '@coog/react-components';
import * as productsActions from '../../Services/Products/actions';
import * as quotationsActions from '../../Services/Quotations/actions';

import './NewQuotation.scss';

class NewQuotation extends Component {
  componentDidMount() {
    const { actions, dateFormat, commercialproducts } = this.props;
    if (Array.isArray(commercialproducts) && commercialproducts.length === 0)
      actions.fetchCommercialProducts({ date: new Date(), dateFormat });
  }

  componentWillUnmount() {
    const { actions } = this.props;
    actions.setRedirectStatus(false);
  }

  handleFetchProducts = date => {
    const { actions, dateFormat } = this.props;
    actions.fetchCommercialProducts({ date, dateFormat });
  };

  handleSelectProduct = product => {
    if (product !== 'undefined' && product.value !== 'undefined') {
      const { value, date } = product;
      const { actions, dateFormat, commercialproducts } = this.props;
      const commercialproduct = find(commercialproducts, { value });
      actions.fetchNewQuotation({
        value: commercialproduct.product,
        date: date || new Date(),
        dateFormat,
        commercialproduct,
      });
    }
  };

  render() {
    const {
      pageTitle,
      canonical,
      productWidget,
      commercialproducts,
      strings,
      isLoadingProducts,
      dateFormat,
      redirect,
      quotationID,
      location,
    } = this.props;

    const to = {
      pathname: `/quotations/${quotationID}`,
      state: { from: location },
    };

    if (redirect) {
      return <Redirect push to={to} preserveQueryString={false} />;
    }

    const helmet = (
      <Helmet>
        <meta charSet="utf-8" />
        <title>{strings[pageTitle] || pageTitle}</title>
        <meta name="description" content={strings[pageTitle] || pageTitle} />
        <link rel="canonical" href={canonical} />
      </Helmet>
    );
    const { product } = productWidget;
    return (
      <div className="coog-app">
        {helmet}
        <h1 className="md-title md-cell md-cell--12">{strings[pageTitle] || pageTitle}</h1>
        <Grid className="coog-grid">
          <ProjectPicker
            widgetTitle={strings[product.title] || product.title}
            widgetSubTitle={strings[product.subtitle] || product.subtitle}
            productLabel={strings[product.label] || product.label}
            productPlaceholder={strings[product.placeholder] || product.placeholder}
            dateLabel={get(strings, 'date.label', "Date d'effet des garanties souhaitée")}
            data={commercialproducts}
            fetchProducts={this.handleFetchProducts}
            selectProduct={this.handleSelectProduct}
            isLoading={isLoadingProducts}
            dateFormat={dateFormat}
          />
        </Grid>
      </div>
    );
  }
}

NewQuotation.propTypes = {
  actions: PropTypes.shape({
    fetchCommercialProducts: PropTypes.func,
    fetchNewQuotation: PropTypes.func,
    setRedirectStatus: PropTypes.func,
  }).isRequired,
  pageTitle: PropTypes.string,
  canonical: PropTypes.string,
  strings: PropTypes.objectOf(PropTypes.string),
  productWidget: PropTypes.shape({
    product: PropTypes.shape({
      label: PropTypes.string,
      placeholder: PropTypes.string,
      title: PropTypes.string,
      subtitle: PropTypes.string,
    }),
    date: PropTypes.shape({
      label: PropTypes.string,
      placeholder: PropTypes.string,
    }),
    data: PropTypes.arrayOf(PropTypes.object),
  }),
  commercialproducts: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.number,
    })
  ),
  isLoadingProducts: PropTypes.bool.isRequired,
  dateFormat: PropTypes.string.isRequired,
  redirect: PropTypes.bool,
  quotationID: PropTypes.string,
  location: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

NewQuotation.defaultProps = {
  pageTitle: 'title.quotation.create',
  canonical: 'http://www.coopengo.com/',
  productWidget: {
    product: {
      title: 'product.title',
      subtitle: 'product.subtitle',
      label: 'product.select.label',
      placeholder: 'product.select.placeholder',
    },
    date: {
      label: 'date',
    },
    data: [],
  },
  commercialproducts: [],
  strings: {},
  redirect: false,
  quotationID: undefined,
};
// eslint-disable-next-line no-unused-vars
const mapStateToProps = state => {
  const commercialproducts = state.toJS().products.commercialproducts.map(product => ({
    value: product.id,
    label: product.rec_name,
  }));
  const { redirect, quotationID } = state.toJS().quotations.current;
  return {
    commercialproducts,
    isLoadingProducts: state.toJS().products.loading.isLoadingProducts,
    strings: state.toJS().quotations.strings,
    dateFormat: state.toJS().system.dateFormat,
    redirect,
    quotationID,
  };
};
// eslint-disable-next-line no-unused-vars
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ ...productsActions, ...quotationsActions }, dispatch),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NewQuotation));
